export default "__VITE_ASSET__50fa4191__"